import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-white/10 bg-navy-900" data-id="element-179" data-mp="1dqrohw3lfk7t">
      <div className="mx-auto w-full max-w-6xl px-4 py-8 sm:px-6" data-id="element-180" data-mp="3r7zmliq4wi9o">
        <p className="font-pixel text-[11px] uppercase tracking-[0.14em] text-white" data-id="element-181" data-mp="3mhj8dwehosm9">
          Math Made Ready 2026
        </p>
        <p className="mt-2 text-sm text-slate-400" data-id="element-182" data-mp="3hj7yjlo72i41">
          Digital printable math activities for Grades 1–5
        </p>
      </div>
    </footer>;
}